import axios from 'axios'
import { envConfig } from '../../../env';

const gmUrl = envConfig.formalServer + "/cotton"             //本地链接
// const gmUrl = 'https://server.cottongame.com/cotton'    //线上链接

export const selAlipayOrderInfo = params => axios.post(gmUrl + '/selAlipayOrderInfo', params)                   // 查询订单信息
export const checkOrderNoExist = params => axios.post(gmUrl + '/checkOrderNoExist', params)                   // 检查订单号是否存在
export const refundOrder = params => axios.post(gmUrl + '/refundOrder', params)                   // 提交退款请求
export const selAlipayRefund = params => axios.post(gmUrl + '/selAlipayRefund', params)                   // 查询退款订单
export const exportExcelAlipayRefund = params => axios.post(gmUrl + '/exportExcelAlipayRefund', params,{responseType: 'blob'})    // 查询退款订单
export const exportExcelAlipayOrder = params => axios.post(gmUrl + '/exportExcelAlipayOrder', params,{responseType: 'blob'})    // 查询退款订单


